import { useCancellationPlanSlice } from 'src/slices/cancellationPlanSlice';

import { createRequiredContext } from '../createRequiredContext';

const [useCancellationPlan, CancellationPlanProvider] = createRequiredContext<{
  ui: ReturnType<typeof useCancellationPlanSlice>;
  exclusiveOfferApplied: boolean;
  cancellationRequested: boolean;
}>();

const CancellationPlanContextProvider = ({
  exclusiveOfferApplied,
  cancellationRequested = false,
  children,
}: {
  exclusiveOfferApplied: boolean;
  cancellationRequested?: boolean;
  children: React.ReactNode;
}) => {
  const ui = useCancellationPlanSlice();

  const providerValue = {
    ui,
    exclusiveOfferApplied,
    cancellationRequested,
  };

  return <CancellationPlanProvider value={providerValue}>{children}</CancellationPlanProvider>;
};

export { useCancellationPlan, CancellationPlanContextProvider };
